import type { DomainMapper } from '../types';

const dk: DomainMapper = {
  countryCode: 'dk',
  currency: 'DKK',
  domain: 'localhost:3011',
  environment: 'local',
  flagUrl: '/flags/DK.svg',
  languagePrimary: true,
  locale: 'da',
  logoUrl: 'kahrs-logo',
  noRobots: true,
  productBasePath: 'produkt',
  sitemapUrl: 'https://kahrs.stage3.iveo.se/storage/sitemaps/sitemap-dk.xml',
  storyblokBasePath: 'dk',
  url: 'https://localhost:3011/dk',
  algoliaIndex: 'b2b-dk-da-DK-products',
  algoliaIndexAutocomplete: 'b2b-dk-da-DK-products_query_suggestions',
  algoliaIndexPages: 'content_',
  applicationId: 1453,
  subFolder: true,
  b2b: {
    enabled: true,
    purchaseEnabled: true,
    storyblokBasePath: 'b2b',
    applicationId: 1453,
    algoliaIndex: 'b2b-dk-da-DK-products',
    algoliaIndexAutocomplete: 'b2b-dk-da-DK-products_query_suggestions',
    displayIncVat: false,
    default: true,
    productBasePath: 'b2b/produkt',
    sitemapUrl: 'https://kahrs.stage3.iveo.se/storage/sitemaps/sitemap-dk.xml',
  },
  b2c: {
    enabled: true,
    purchaseEnabled: true,
    storyblokBasePath: '',
    applicationId: 1471,
    algoliaIndex: 'b2c-dk-da-DK-products',
    algoliaIndexAutocomplete: 'b2c-dk-da-DK-products_query_suggestions',
    displayIncVat: true,
    default: false,
    productBasePath: 'produkt',
    sitemapUrl: 'https://kahrs.stage3.iveo.se/storage/sitemaps/sitemap-dk-b2c.xml',
  },
  features: {
    fastOrder: true,
    backorders: false,
    cartSettings: true,
  },
  showNonPublicProducts: true,
} as DomainMapper;

export default dk;
